import React, { Component } from 'react';
import store from 'app/store';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import * as types from 'actions/action_types';
import { scope } from 'actions/Map/map.scope.action';
import { URL } from 'app/constants/mapConstants';
import { FormattedMessage } from 'react-intl';
import { notification } from 'antd';
import List from '../List/list.container';

import pageDataAPI from '../../../API/pageData.api';
import pageCache from '../../../API/cache.service';

import translatedText from './translatedText';

let _setTimeNotific;
class MyFriendsTours extends Component {
  updateMapContent = () => {
    setTimeout(() => {
      store.dispatch((dispatch) => {
        dispatch({
          type: types.FETCH_TOURS_PUBLIC,
          payload: pageDataAPI.getMyFriendsTours(),
        });
        dispatch(scope('tour'));
      });
    }, 100);
  };

  componentDidMount() {
    // this.updateMapContent();
    if (!this.props.isLogin) {
      const args = {
        message: this.props.translatedTexts['Login to see your friends tours'],
        duration: 0,
        top: 80,
      };
      _setTimeNotific = setTimeout(() => {
        notification.warning(args);
      }, 1000);
    }
  }

  shouldComponentUpdate(nextProps) {
    if (
      this.props.location.pathname === nextProps.location.pathname &&
      this.props.isLogin === nextProps.isLogin
    )
      return false;
    return true;
  }

  componentDidUpdate(nextProps) {
    if (
      this.props.isLogin !== nextProps.isLogin &&
      this.props.location.pathname &&
      this.props.location.pathname.indexOf('friendtour') > -1
    ) {
      pageCache.destroy(URL.TOUR.FRIENDS[0]);
      // this.updateMapContent();
    }
    if (
      nextProps.isLogin !== this.props.isLogin &&
      this.props.isLogin === true
    ) {
      clearTimeout(_setTimeNotific);
    }
  }

  componentWillUnmount() {
    store.dispatch({
      type: types.FETCH_TOURS_PUBLIC_FULFILLED,
      payload: [],
    });
    store.dispatch({ type: types.FETCH_PREVIEW_DATA_CLEANE });
    clearTimeout(_setTimeNotific);
    // notification.destroy();
  }

  getLabel = () => (
    <FormattedMessage id="Friend tours" defaultMessage="Friend tours" />
  );

  render() {
    return (
      <Route
        path={`${this.props.match.url}/list`}
        render={() => <List label={this.getLabel()} />}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  isLogin: state.authentication.isLoggedIn,
});

export default connect(mapStateToProps)(translatedText(MyFriendsTours));
